import { render, staticRenderFns } from "./OfferCosts.vue?vue&type=template&id=8aafee90"
import script from "./OfferCosts.vue?vue&type=script&lang=ts"
export * from "./OfferCosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports